module.exports = __webpack_public_path__ + "static/media/doom_bringer.f4b8da79.png";